import type { FaireProductEntity } from "../../entity_types/product";

export const p_t8jyfyhq7b: FaireProductEntity = {
  token: "p_t8jyfyhq7b",
  type: "product",
  name: "Any Good Lunches Miss You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/18dff314d9701b34f78b7091ae49b4880d136205bc13f00a525d87c15a79be94.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a8094084d48019cef0e2b6b9e1bc0ef5aa5f98ab5f2cfd434c08bf5c2a8579b.png",
    "https://cdn.faire.com/fastly/80238f44183a86fc3c93c48a848c2bb44cfa97a575cf34ce7a2eaa63036155f7.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:09.323Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
